import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=51ee24e7&scoped=true"
var script = {}
import style0 from "./Thanks.vue?vue&type=style&index=0&id=51ee24e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee24e7",
  null
  
)

export default component.exports